import { z } from 'zod';

const passwordStrengthRegex =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?#&_])[A-Za-z\d@$!%*?#&_]{8,}$/;

export const registerSchema = z
  .object({
    image: z.any().optional(),
    username: z.string().min(4, "Username is required"),
    email: z
      .string()
      .email("Invalid email address")
      .min(1, "Email is required"),
    password: z
      .string()
      .min(8, "Password must be at least 8 characters")
      .regex(
        passwordStrengthRegex,
        "Password must include uppercase, lowercase, number, and special character"
      ),
    confirmPassword: z
      .string()
      .min(8, "Please confirm your password"),
  })
  
  .refine((data) => data.password === data.confirmPassword, {
    path: ["confirmPassword"],
    message: "Passwords do not match",
  });
  
